import React, { useEffect, useContext, useState } from "react";
import { Footer, Header, LoginHeader } from "../../components";
import "./styles.css";
import { Images } from "../../theme";
import { Link, useNavigate } from "react-router-dom";
import { GlobalContext } from "../../context/GlobalContext";
import { useTranslation } from "react-i18next";

export default function Lending() {
  const getContextItem = useContext(GlobalContext);
  let { user_data, loginData } = getContextItem;
  let navigate = useNavigate();
  const { t } = useTranslation();

  const [isActiveLogin, setIsActiveLogin] = useState(false);

  useEffect(() => {
    user_data();
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      {loginData?.id ? (
        <Header />
      ) : (
        <LoginHeader
          loginIsActive={isActiveLogin}
          setIsActiveLogin={setIsActiveLogin}
        />
      )}
      <div className="container">
        <div className="row">
          <div className="col-12 mt-3 mb-3">
            <Link to="/">
              <span className="homeHeading">{t("Home")}</span>
            </Link>
            <span className="arrowStyle">
              {" "}
              <img src={Images.ArrowNew} alt="image" />{" "}
            </span>
            <span className="pageHeading">{t("How_Lending_Works")}</span>
          </div>
        </div>
      </div>
      <div className="container">
        <div className="row">
          <div className="col-12 p-0">
            <div className="blueCard">
              <h1 className="blueCardHeading">{t("Lend_Start_Earning")}</h1>
              <p className="blueCardDes">
                {t("Lend_Start_Earning_Description")}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="container">
        <div className="row my-5 pt-5 lent-rent-pad">
          <div className="col-md-5 col-lg-5 m-auto spacingRightStyle">
            <p className="cartHeading">{t("Before_Lending")}</p>
            <div>
              <span className="lightHeading">{t("List_An_Item")} </span>
              <span className="lightDesc">{t("List_Item_Description")}</span>
            </div>
            <div>
              <span className="lightHeading">{t("Update_Availability")}</span>
              <span className="lightDesc">
                {t("Update_Availability_Description")}{" "}
              </span>
            </div>
            <div>
              <span className="lightHeading">{t("Respond_promptly")}</span>
              <span className="lightDesc">
                {t("Respond_promptly_Description")}
              </span>
            </div>
          </div>
          <div className="col-lg-1 d-none-tablet"></div>
          <div className="col-md-6 col-lg-6 text-center">
            <img src={Images.l1} alt="image" style={{ width: "80%" }} />
          </div>
        </div>

        <div className="row my-5 pt-5 column-reverse">
          <div className="col-md-6 col-lg-6  text-center">
            <img src={Images.l2} alt="image" style={{ width: "80%" }} />
          </div>
          <div className="col-lg-1 d-none-tablet"></div>

          <div className="col-md-5 col-lg-5 m-auto spacingLeftStyle">
            <p className="cartHeading">{t("When_Lending")}</p>
            <div>
              <span className="lightHeading">{t("Meet_The_User")} </span>
              <span className="lightDesc">{t("Arrange_To_Meet")}</span>
            </div>
            <div>
              <span className="lightHeading">{t("Keep_Touch")} </span>
              <span className="lightDesc">{t("Keep_Touch_Description")}</span>
            </div>
            <div>
              <span className="lightHeading">{t("Retrieve_Item")}</span>
              <span className="lightDesc">
                {t("Retrieve_Item_Description")}
              </span>
            </div>
          </div>
        </div>

        <div className="row my-5 pt-5">
          <div className="col-md-5 col-lg-5 m-auto spacingRightStyle">
            <p className="cartHeading">{t("After_Lending")}</p>
            <div>
              <span className="lightHeading">{t("Rate_The_User")} </span>
              <span className="lightDesc">
                {t("Rate_The_User_Description")}
              </span>
            </div>
            <div>
              <span className="lightHeading"> {t("Repeat")}</span>
              <span className="lightDesc">{t("List_More_Items")}</span>
            </div>
          </div>
          <div className="col-lg-1 d-none-tablet"></div>

          <div className="col-md-6 col-lg-6 text-center">
            <img src={Images.r3} alt="image" style={{ width: "80%" }} />
          </div>
        </div>

        <div className="row my-5 pt-5 column-reverse">
          <div className="col-md-6 col-lg-6 text-center">
            <img src={Images.r4} alt="image" style={{ width: "80%" }} />
          </div>
          <div className="col-lg-1 d-none-tablet"></div>

          <div className="col-md-5 col-lg-5 m-auto spacingLeftStyle">
            <p className="cartHeading">{t("Play_Your_Part")}</p>
            <div>
              <span className="lightDesc">
                {t("Play_Your_Part_Description")}.
              </span>
            </div>
          </div>
        </div>
      </div>

      <div className="container">
        <div className="row">
          <div className="col-12 btnMobileView">
            <button
              onClick={() =>
                loginData.id ? navigate("/Listanitem") : setIsActiveLogin(true)
              }
              class="btn-custom btn-light mb-5"
            >
              {t("List_Earn")}
            </button>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
}
